// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"1f4daeac","501":"f47e04c9","778":"a432fe82","899":"c7445a85"}[chunkId] + ".css";
};